import { Component, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { Store } from '@ngrx/store';
import { Field, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import type { FormGroupState } from 'ngrx-forms';
import { AbstractControlState } from 'ngrx-forms';
import { NgClass } from '@angular/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { ProgressiveFormService } from '../progressive-form.service';

@Component({
  selector:
    'wl-progressive-form-value-progress-button[rendering][buttonText][value][control][progressiveFormSelectorKey][stepId]',
  templateUrl: './progressive-form-value-progress-button.component.html',
  styleUrls: ['./progressive-form-value-progress-button.component.scss'],
  standalone: true,
  imports: [
    JssModule,
    CSCaptureDirective,
    TrackLinkDirective,
    AutomationIdDirective,
    NgClass,
  ],
})
export class ProgressiveFormValueProgressButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InnogyComponentRendering | any;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonText!: Field<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() buttonType?: 'button' | 'button-outline' = 'button';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() value!: any;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control?: AbstractControlState<any>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState?: FormGroupState<any> | null;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepId?: string;

  get currentStepIndex$() {
    return this.progressiveFormService.currentStepPresentableNumber$(
      this.progressiveFormSelectorKey,
      this.stepId
    );
  }

  constructor(
    private readonly store$: Store,
    private readonly progressiveFormService: ProgressiveFormService
  ) {}

  submitForm() {
    if (!this.control || !this.stepId) {
      return;
    }
    this.store$.dispatch(
      this.progressiveFormService.setValueAndSubmit({
        formId: this.progressiveFormSelectorKey,
        value: this.value,
        controlId: this.control.id,
        stepId: this.stepId,
      })
    );
  }
}
